module.exports = __webpack_public_path__ + "static/media/file-image.f8d28c3e.svg";